<template>
    <div
      class="bg-white px-3"
      style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
    >
      <div v-if="createModel">
        <div class="mb-2 mt-2 pt-3">
          <template>
          <el-header style="float: left;">{{ com_info.com_no  }} - {{ com_info.title  }}</el-header>
          </template>
          <div style="float: right;">
            <!-- <el-button type="primary"  @click="submit(scope.row.id, 2, '您確定要直接發佈嗎？')">發佈成績</el-button> -->
          <el-button @click="resetForm">返 回</el-button>
          </div>
        </div>
        <div slot="footer" style="text-align: center; padding: 10px 0 30px 0">
		 
		</div>
       
        <el-form
          ref="form"
          :model="form"
          :label-width="layout.is_phone ? '80px' : '100px'"
        >
          <el-form-item prop="groupList">
              <el-table
                  :data="groupList"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  :row-class-name="tableRowClassName" 
              >
                  <el-table-column
                  align="center"
                  prop="name"
                  label="組別名稱"
                  ></el-table-column>
  
                  <el-table-column
                  align="center"
                  prop="total_score"
                  label="試卷總分"
                  ></el-table-column>
  
                  <el-table-column
                align="center"
                prop="participant_count"
                label="參賽人數"
                ></el-table-column>


                <el-table-column
                align="center"
                prop="paper_count"
                label="比賽人數"
                ></el-table-column>
                
                  <el-table-column
                  align="center"
                  prop="check_count"
                  label="未改試卷"
                  ></el-table-column>
  
                  <el-table-column
                  align="center"
                  prop="time"
                  label="時長限制"
                  ></el-table-column>
  
                  <el-table-column
                    align="center"
                    label="榜單顯示人數"
                  >
                    <template slot-scope="scope">
                   
                        <!-- 显示模式 -->
                    
                        <el-button @click="startEditing(scope)"  v-auth="'delRule'" size="mini" plain type="warning">{{ scope.row.rank_num }}</el-button>
                    
                    </template>
                  </el-table-column>
  
                  <el-table-column prop="id" align="center" width="140" label="操作">
                  <template slot-scope="scope">
                      <el-button-group>
                      <el-button
                          size="mini"
                          plain
                          type="primary"
                          @click="addRanking(scope.row.id)"
                          >查看</el-button
                      >
                      <el-button
                          size="mini"
                          plain
                          type="warning"
                          @click="jieguo(scope.row.id)"
                          >預覽</el-button
                      >
                      </el-button-group>
                  </template>
                  </el-table-column>
              </el-table>
          </el-form-item>
  
        <div class="mb-2 mt-2 pt-3">
          
          <button-search
            :isphone="layout.is_phone"
            ref="buttonSearch"
            placeholder="搜索學生名稱"
            @search="searchEventTopic"
            :showGj="true"
          >
              <template #left>
              <el-button type="primary" style="margin-right: 20px;" v-auth="'add'+auth_val" @click="queue" size="mini">快速排名</el-button>
              <el-tag  v-for="item in formQueue" :key="item.id" >{{item.level_name}}: {{item.num}}</el-tag>
            </template>
            <template #from>
              <el-form inline ref="form" :model="fromTopic" label-width="100px">
                <el-form-item label="學生名稱" class="mb-0">
                  <el-input
                    size="small"
                    v-model="fromTopic.name"
                    placeholder="學生名稱（模糊搜索）"
                  ></el-input>
                </el-form-item>

                <el-form-item label="學生編號" class="mb-0">
                  <el-input
                    size="small"
                    v-model="fromTopic.user_no"
                    placeholder="學生編號（模糊搜索）"
                  ></el-input>
                </el-form-item>
  
                <el-form-item label="學校名稱" class="mb-0">
                  <el-input
                    size="small"
                    v-model="fromTopic.school_name"
                    placeholder="學校名稱（模糊搜索）"
                  ></el-input>
                </el-form-item>
  
                <el-form-item label="學生郵件" class="mb-0">
                  <el-input
                    size="small"
                    v-model="fromTopic.email"
                    placeholder="學生郵件（模糊搜索）"
                  ></el-input>
                </el-form-item>
  
  
                <el-form-item class="mb-0">
                  <el-button type="info" @click="searchEventTopic" size="small"
                    >搜索
                  </el-button>
                  <el-button size="small" @click="clearSearchTopic"
                    >清空篩選條件</el-button
                  >
                </el-form-item>
  
                
              </el-form>
            </template>
          </button-search>

        
        </div>
  
        <!-- 表格 -->
        <div class="mt-3 pt-2">
          <el-table
            :data="userTopicList"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
             
              <el-table-column align="center" width="80" sortable prop="rank" label="排名">
            </el-table-column>
            <el-table-column align="center" prop="join_no" label="報名編號">
            </el-table-column>
            <el-table-column align="center" prop="topic_no" width="200"  label="參加編號">
            </el-table-column>
              
              <el-table-column align="center" prop="user_no" label="學生編號">
              </el-table-column>
              <el-table-column align="center" prop="name" label="學生名稱">
              </el-table-column>
              <el-table-column align="center" prop="school_name" label="學校名稱">
              </el-table-column>
              <el-table-column align="center" prop="email" label="學生信箱">
              </el-table-column>
              <el-table-column align="center" prop="score" label="成績">
              </el-table-column>
              <el-table-column align="center" prop="yes_num" label="答對數量">
              </el-table-column>
              <el-table-column align="center" prop="use_time_text" label="做題時長">
              </el-table-column>
              <el-table-column align="center" prop="level_id" label="名次">
                <template slot-scope="scope">
                <el-select 
                  v-model="scope.row.level_id" 
                  placeholder="請選擇" 
                  @change="handleLevelChange(scope.row,1)"
                  :disabled="!scope.row.is_none">
                  <el-option
                    v-if="!scope.row.is_none"
                    :key="0"
                    label="缺席"
                    :value="0">
                  </el-option>
                  <el-option
                    v-else
                    :key="0"
                    label="未選擇"
                    :value="0">
                  </el-option>
                  <el-option
                    v-for="item in formQueue"
                    :key="item.id"
                    :label="item.level_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </template>
              </el-table-column>
  
              
              <el-table-column prop="id" align="center" width="120" label="操作">
                  <template slot-scope="scope">
                  <el-button-group>
                      <el-button
                      size="mini"
                      plain
                      type="primary"
                      v-auth="'edit' + auth_val"
                      @click="updateTopic(scope.row,1)"
                      >修改分數</el-button
                      >
                  </el-button-group>
                  </template>
              </el-table-column>
          </el-table>
          <el-footer
              class="d-flex bg-white align-items-center px-0"
              style="float: right;"
          >
              <!-- 底部 -->
  
              <div style="flex: 1" class="px-2">
                  <el-pagination
                      :current-page="pageScore.current"
                      :page-sizes="pageScore.sizes"
                      :page-size="pageScore.size"
                      @size-change="handleScoreSizeChange"
                      @current-change="handleScoreCurrentChange"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="pageScore.total"
                  >
                  </el-pagination>
              </div>
          </el-footer>
        </div>
  
       
          
        </el-form>
       
        <el-dialog :close-on-click-modal="false"  :visible.sync="updateRankNum" title="修改">
          <el-form :rules="rules"  ref="formRank" :model="formRank" :label-width="layout.is_phone?'80px':'130px'">
            <el-form-item label="組別名稱" prop="name">
                  <el-input v-model="formRank.name" disabled size="small" 
                  style="width: 85%;"></el-input>
              </el-form-item>
              <el-form-item label="榜單顯示人數" prop="num">
                  <el-input v-model="formRank.num"  size="small" 
                  style="width: 85%;"></el-input>
              </el-form-item>
          </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="updateRankNum = false">取 消</el-button>
              <el-button type="primary" @click="submitRankNum">確 定</el-button>
          </div>
          </el-dialog>

          <el-dialog :close-on-click-modal="false"  :visible.sync="groupRankModel" title="結果預覽" top="5vh" :width="layout.is_phone?'90%':'50%'">
            <el-table
              :data="groupRankList"
              border
              style="width: 100%"
              @selection-change="groupRankList"
            >
              
              <el-table-column align="center" width="80" prop="rank_level" label="排名">
              </el-table-column>
                <el-table-column align="center" prop="name" label="學生名稱">
                </el-table-column>
                <el-table-column align="center" prop="school_name" label="學校名稱">
                </el-table-column>
                <el-table-column align="center" prop="level" label="學生等級">
                </el-table-column>
                <el-table-column align="center" prop="level_id" label="名次" width="150">
                  <template slot-scope="scope">
                  <el-select 
                    v-model="scope.row.rank_id" 
                    placeholder="請選擇" 
                    @change="handleLevelChange(scope.row,2)">
                    <el-option
                      v-for="item in formQueue"
                      :key="item.id"
                      :label="item.level_name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </template>
                </el-table-column>
    
                
                <el-table-column prop="id" align="center" width="120" label="操作">
                    <template slot-scope="scope">
                    <el-button-group>
                        <el-button
                        size="mini"
                        plain
                        type="primary"
                        v-auth="'edit' + auth_val"
                        @click="updateTopic(scope.row,2)"
                        >修改排名</el-button
                        >
                    </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
              <el-button @click="groupRankModel = false">關 閉</el-button>
          </div>
          </el-dialog>

  
        <el-dialog :close-on-click-modal="false"  title="修改名次" :visible.sync="createQueueModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
          <!-- 表單内容 -->
          <el-form ref="form" :model="formQueue" :label-width="layout.is_phone ? '80px' : '100px'">
            <div v-for="(item) in formQueue" :key="item.id">
              <el-form-item :label="item.level_name" :prop="`score_${item.id}`">
                <el-input
                  v-model="item.minScore"
                  placeholder="最低分數"
                  clearable
                  size="small"
                  type="number"
                  style="width: 40%; display: inline-block;"
                ></el-input>
                <span style="margin: 0 10px;">-</span>
                <el-input
                  v-model="item.maxScore"
                  placeholder="最高分數"
                  clearable
                  size="small"
                  type="number"
                  style="width: 40%; display: inline-block;"
                ></el-input>
                <span v-if="item.scoreWarning" style="color: red;">{{ item.scoreWarning }}</span> <!-- 顯示错误信息 -->
              </el-form-item>
            </div>
          </el-form>
  
          <div slot="footer" class="dialog-footer">
            <el-button @click="createQueueModel = false">取 消</el-button>
            <el-button type="primary" @click="submitQueue">確 定</el-button>
          </div>
        </el-dialog>
      
  
          <el-dialog :close-on-click-modal="false"  title="修改成績" :visible.sync="createTopicModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
              <!-- 表單内容 -->
              <el-form ref="form" :model="formTopic" :label-width="layout.is_phone?'80px':'100px'">
  
                  <el-form-item label="學生姓名" prop="name">
                      <el-input v-model="formTopic.name" disabled size="small" 
                       style="width: 85%;"></el-input>
                  </el-form-item>
                  <el-form-item label="學校" prop="school_name">
                      <el-input v-model="formTopic.school_name" disabled size="small"
                       style="width: 85%;"></el-input>
                  </el-form-item>
                  <el-form-item label="郵箱" prop="email" v-if="createTopicType == 1">
                      <el-input v-model="formTopic.email" disabled size="small" style="width: 85%;"></el-input>
                  </el-form-item>
  
          <el-form-item label="目前排名" prop="rank">
                      <el-input v-model="formTopic.rank"   size="small" style="width: 85%;"></el-input>
                  </el-form-item>
  
                  <el-form-item label="分數" prop="score" v-if="createTopicType == 1">
                      <el-input v-model="formTopic.score" placeholder="為空預設0" clearable size="small" style="width: 85%;"></el-input>
                  </el-form-item>
                  
                  <el-form-item label="做題時長" prop="use_time" v-if="createTopicType == 1">
                      <el-input v-model="formTopic.use_time" placeholder="為空預設0" clearable size="small" style="width: 85%;"></el-input>
                  </el-form-item>
              </el-form>
  
  
              <div slot="footer" class="dialog-footer">
                  <el-button @click="createTopicModel = false">取 消</el-button>
                  <el-button type="primary" @click="submitTopic">確 定</el-button>
              </div>
          </el-dialog>
      </div>
  
      <div v-else>
        <div class="mb-2 mt-2 pt-3">
          <button-search
            :isphone="layout.is_phone"
            ref="buttonSearch"
            placeholder="搜索比賽編號"
            @search="searchEvent"
            :showGj="true"
          >
            <!-- 左边 -->
  
            <!-- 高級搜索 -->
            <template #from>
              <el-form inline ref="form" :model="from" label-width="100px">
                <el-form-item label="比賽名稱" class="mb-0">
                  <el-input
                    size="small"
                    v-model="from.title"
                    placeholder="比賽名稱（模糊搜索）"
                  ></el-input>
                </el-form-item>
                
                <el-form-item label="比賽編號" class="mb-0">
                  <el-input
                    size="small"
                    v-model="from.com_no"
                    placeholder="比賽編號（模糊搜索）"
                  ></el-input>
                </el-form-item>

                 
                <el-form-item label="機構" class="mb-0">
                  <el-input
                    size="small"
                    v-model="from.ins_name"
                    placeholder="機構（模糊搜索）"
                  ></el-input>
                </el-form-item>


                <el-form-item label="審核狀態" class="mb-0">
                  <el-select v-model="from.audit_status" size="small">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="未提交" :value="0"></el-option>
                    <el-option label="待審核" :value="1"></el-option>
                    <el-option label="已審核" :value="2"></el-option>
                    <el-option label="已拒絕" :value="3"></el-option>
                  </el-select>
                </el-form-item> 
  
                <!-- <el-form-item label="狀態" class="mb-0">
                  <el-select v-model="from.status" size="small">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="啟用" :value="1"></el-option>
                    <el-option label="禁用" :value="0"></el-option>
                  </el-select>
                </el-form-item>
   -->
                <el-form-item class="mb-0">
                  <el-button type="info" @click="searchEvent" size="small"
                    >搜索
                  </el-button>
                  <el-button size="small" @click="clearSearch"
                    >清空篩選條件</el-button
                  >
                </el-form-item>
  
                
              </el-form>
            </template>
          </button-search>
          
        </div>
  
        <!-- 表格 -->
        <div class="mt-3 pt-2">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
         
            <el-table-column align="center" prop="com_no" label="比賽編號" width="100">
            </el-table-column>
            <el-table-column align="center" prop="title" label="比賽名稱">
								<template slot-scope="scope">
									<!-- <div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else> -->
										{{ scope.row.title }}
									<!-- </div> -->
								</template>
					</el-table-column>
            <el-table-column align="center" prop="subject_name" label="學科名稱" width="100">
            </el-table-column>
  
            <el-table-column
            align="center"
            width="100"
            prop="content"
            label="簡介"
          >
          <template slot-scope="scope">
            <el-popover
              trigger="click"
              style="cursor: pointer"
              placement="top"
              width="100"
            >
              <!-- 使用 v-html 來渲染 HTML 內容 -->
              <p style="width: 300px" v-html="scope.row.content"></p>
              
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">查看</el-tag>
              </div>
            </el-popover>
          </template>
          </el-table-column>
  
           
  
            <el-table-column align="center" prop="school_name" label="參加學校">
            </el-table-column>
           
  
            <el-table-column align="center" prop="ins_name" label="機構">
            </el-table-column>
  
            <el-table-column align="center" prop="audit_status" label="審核狀態" width="100">
              <template slot-scope="scope">
                <span class="text-primary" v-if="scope.row.audit_status == 0">未提交</span>
                <span class="text-warning" v-if="scope.row.audit_status == 1">待審核</span>
                <span class="text-success" v-if="scope.row.audit_status == 2">已審核</span>
                <span class="text-danger" v-if="scope.row.audit_status == 3">已拒絕</span>
              </template>
            </el-table-column>
  
            <el-table-column align="center" prop="status" label="狀態" width="100">
              <template slot-scope="scope">
                <el-button
                  :type="scope.row.status ? 'success' : 'danger'"
                  size="mini"
                  @click="changeStatus(scope.row)"
                  plain
                  >{{ scope.row.status ? "顯示" : "隱藏" }}
                </el-button>
              </template>
            </el-table-column>
  
            <el-table-column
              align="center"
              width="180"
              prop="update_time"
              label="提交時間"
              
            >
            </el-table-column>
            <el-table-column prop="id" align="center" label="操作">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    size="mini"
                    plain
                    type="primary"
                    v-auth="'edit' + auth_val"
                    @click="openModel(scope.row.id)"
                    >查看</el-button>
                  <el-button
                      v-if="scope.row.audit_status == 1"
                      size="mini"
                      plain
                      type="success"
                      v-auth="'edit' + auth_val"
                      @click="submit(scope.row.id, 2, '您確定要通過審核嗎？')"
                  >通過</el-button>
                  <el-button
                    v-if="scope.row.audit_status == 1"
                      size="mini"
                      plain
                      type="warning"
                      v-auth="'edit' + auth_val"
                      @click="submit(scope.row.id, 3, '您確定要拒絕審核嗎？')"
                  >拒絕</el-button>

                 
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
  
        <div style="height: 60px"></div>
        
        <el-footer
          class="d-flex border-top bg-white align-items-center px-0 position-fixed"
          style="bottom: 0; left: 200px; right: 0; z-index: 100"
        >
          <!-- 底部 -->
  
          <div style="flex: 1" class="px-2">
            <el-pagination
              :current-page="page.current"
              :page-sizes="page.sizes"
              :page-size="page.size"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </el-footer>
      </div>
      <div slot="footer" style="text-align: center; padding: 30px 0 30px 0">
		 
		</div>
    <el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="題目">
			<p>{{ fullTitle }}</p>
		</el-dialog>

  
    </div>
  </template>
  
  <script>
  import { commondecrypt } from "@/main";
  import common from "@/common/mixins/common.js";
  import buttonSearch from "@/components/common/button-search.vue";
  import { mapState } from 'vuex';
  export default {
    components: {
      buttonSearch,
    },
    inject: ["layout", "app"],
    mixins: [common],
    data() {
      return {
        dialogTitleVisible: false,
				fullTitle: '',
        selectedRowId: null,  // 保存选中行的ID
        createModel: false,
        createQueueModel: false,
        updateRankNum: false,
        editIndex: -1,
  
        com_info:[],
        rankList:[],
  
        createTopicModel:false,
        createTopicType:1,
        formTopic:{},
        formQueue:{},
        formRank:{},
      
        scoreId: 0,
        pageScore: {
                  current: 1,
                  sizes: [50, 100, 200, 300, 500],
                  size: 200,
                  total: 0
              },
        //搜索數据
        from: {
          title: "",
          com_no: "",
          ins_name: "",
          pay_type: -1,
          audit_status: -1,
          status: -1,
          time: [],
        },
        //搜索數据
        fromTopic: {
          name: "",//學生名稱
          user_no:"",
          school_name: "",//學校名稱
          email: "",//學生郵件
        },
        auth_val: "Shop",
        preUrl: "data/checkList", //列表地址
        addUrl: "data/editCompetitionAudit", //添加/修改地址
        editStatusUrl:"data/editStatusCompetition",//修改狀態地址
  
        tableData: [],
        form: {},
        groupList: [],//比賽科目列表
        userTopicList: [],//參加科目學生列表
        
        label_ids: null,
       
  
        active: 0, //步骤數
        inputVisible: false,
        groupRankModel: false,
        inputValue: "",
        label_list: [],
        all_label_list: [],
        subject_list: [],
        school_list: [],
        grade_list: [],
        rule_list: [],
        check_img_list: [],
        groupRankList: [],

        rules: {
					
				num: [
						{
						required: true,
						message: "榜單顯示人數不能為空",
						trigger: 'blur',
						},
						{
						validator: (rule, value, callback) => {
							if (value < 3) {
							callback(new Error("榜單顯示人數不能小於 3"));
							} else {
							callback();
							}
						},
						trigger: 'blur'
						}
					],
				},
      };
    },
  
    created() {
      this.commonList(["school_list", "topic_subject_label"]);
    },
    computed: {
      ...mapState(['refreshTrigger']), // 监听 Vuex state
      processedGradeList() {
        // 創建一个新數組，確保不直接修改原始數据
        return this.grade_list.map((grade) => {
          // 检查 this.form.paperList 中任一 paper 的 grade_id 數組是否包含當前 grade 的 id
          const isDisabled = this.form.paperList.some((paper) =>
            paper.grade_id.includes(Number(grade.id))
          );
          // 返回新的对象，并可能添加 disabled 属性
          return {
            ...grade,
            disabled: isDisabled,
          };
        });
      },
    },
    watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		
    methods: {
     
       //修改排序
      queue(){
        this.createQueueModel = true;
      },
      jieguo(com_info_id){
        this.layout.loading = true;
        this.axios
         .post(
            "/admin/data/getGroupRank",
            {
              info_id: com_info_id,
            },
            {
              token: true,
            }
          )
         .then((res) => {
          if(res.data.code == 1){
            const all = res.data.data.list
            this.groupRankList = all.list
            this.layout.loading = false;
            this.groupRankModel = true;
            this.formQueue = all.rank
          }else{
            this.$message.error(res.data.msg)
          }
         })
      },
      handleLevelChange(row,type) {
          row.rank_type = 1
          row.types = type
          this.layout.loading = true;
          // 在这里可以执行其他逻辑，例如更新數据或触发其他操作
          this.axios.post(
            "/admin/data/updateRank",
            row,
            {
              token: true,
            }
          )
          .then((res) => {
            // 修改成功则不操作
            this.layout.loading = false;

          })
          .catch((err) => {
            // 修改失敗时恢复下拉框选项值
            this.layout.loading = false; // 停止加載狀態
          });
        },
        startEditing(res) {
          // 设置当前行为编辑模式
          this.formRank = {
            id:res.row.id,
            name:res.row.name,
            num:res.row.rank_num,
          }
          this.updateRankNum = true
          
        },
        submitRankNum(){
          this.$refs.formRank.validate((valid) => {
            if (valid) {
              this.axios.post(
                "/admin/data/updateRankNum",
                this.formRank,
                {
                    token: true,
                }
                )
                .then((res) => {
                  if (res.data.code === 1) {
                    this.groupList.forEach((item, index) => {
                      if (item.id === this.formRank.id) {
                        item.rank_num = this.formRank.num;
                      }
                    });
                  }
                  this.updateRankNum = false; // 關閉模型
                })
                .catch((err) => {
                // 失敗
                this.updateRankNum = false; // 關閉模型
              });
            }
          });
        },
      
      submitQueue() {
        this.layout.loading = true;
        this.axios.post(
              "/admin/data/updateRank",
              {rank_type:2,data:this.formQueue,com_info_id:this.scoreId},
              {
                  token: true,
              }
              )
              .then((res) => {
                  this.addRanking(this.formTopic.com_info_id)
                  this.createQueueModel = false;
              })
              .catch((err) => {
              // 失敗
              this.layout.loading = false;
              this.createQueueModel = false; // 關閉模型
        });
      
      },
       // 清空篩選條件
       clearSearchTopic() {
        this.fromTopic = {
          name: "",//學生名稱
          user_no:"",
          school_name: "",//學校名稱
          email: "",//學生郵件
        };
  
        //this.$refs.buttonSearch.closeSuperSearch();
        this.search = "";
        this.getList();
      },
      searchEventTopic(e = false) {
              // 簡單搜索
              if (typeof e === 'string') {
                  this.search = e;
                  this.getUserTopicList()
                  return
              }
              this.search = this.fromTopic
              this.getUserTopicList()
          },
      //修改成績弹框
      updateTopic(data,type){
          if(type == 1){
            this.formTopic = {
              score : data.score,
              use_time : data.use_time,
              name : data.name,
              school_name : data.school_name,
              email : data.email,
              rank : data.rank,
              com_info_id : data.com_info_id,
              id : data.is_none,
              user_com_id : data.id,
            }
          }else{
            this.formTopic = {
              score : data.score,
              id : data.id,
              name : data.name,
              school_name : data.school_name,
              rank : data.rank_level,
              com_info_id : data.com_info_id,
            }
          }
          
          this.createTopicModel = true;
          this.createTopicType = type;
      },
     
      //修改成績并重新排名
      submitTopic(){
        this.formTopic.types = this.createTopicType;
          this.axios
              .post(
              "/admin/data/updateTopic",
              this.formTopic,
              {
                  token: true,
              }
              )
              .then((res) => {
                if(this.createTopicType == 1){
                  this.addRanking(this.formTopic.com_info_id)
                }else{
                  this.jieguo(this.formTopic.com_info_id)
                }
                  this.createTopicModel = false;
              })
              .catch((err) => {
              // 失敗
              this.layout.loading = false;
          });
         
          this.resetTagForm();
      },
      // 打开模态框
      openModel(e) {
        this.layout.loading = true;
        this.axios
          .post(
            "/admin/data/getGroupList",
            {
              id: e,
            },
            {
              token: true,
            }
          )
          .then((res) => {
            this.userTopicList = []
            this.groupList = res.data.data.list.list,
            this.com_info = res.data.data.list.com_info
            this.editIndex = e;
            // 打开dialog
            this.createModel = true;
            this.layout.loading = false;
          })
          .catch((err) => {
            // 失敗
            this.layout.loading = false;
          });
      },
      
      tableRowClassName({ row }) {
        // 判断行的 ID 是否与选中的 ID 相等，返回不同的類名
        return row.id === this.selectedRowId ? 'selected-row' : '';
      },
       // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
      addRanking(e){
          if(e){
              this.scoreId = e;
              this.selectedRowId = e;
          }
          this.layout.loading = true;
          this.axios
              .post(
              "/admin/data/getUserTopicList",
              {
                  id: this.scoreId,
                  page: this.pageScore.current,
                          limit: this.pageScore.size,
              },
              {
                  token: true,
              }
              )
              .then((res) => {
                  let all = res.data.data.list
                  this.pageScore.total = all.total
                  this.userTopicList = all.list
                  this.formQueue = all.rank
                  this.layout.loading = false;
              })
              .catch((err) => {
              // 失敗
              this.layout.loading = false;
          });
      },
      getUserTopicList(){
          this.layout.loading = true;
          this.axios
              .post(
              "/admin/data/getUserTopicList",
              {
                id: this.scoreId,
                search: this.search,
              },
              {
                token: true,
              }
              )
              .then((res) => {
                  let all = res.data.data.list
                  this.pageScore.total = all.total
                  this.userTopicList = all.list
                  this.formQueue = all.rank
                  this.layout.loading = false;
              })
              .catch((err) => {
              // 失敗
              this.$message.error(err);
              this.layout.loading = false;
          });
      },
      handleScoreSizeChange(val) {
              this.pageScore.size = val
              this.addRanking()
      },
      handleScoreCurrentChange(val) {
          this.pageScore.current = val
          this.addRanking()
      },
      //提交成績
      submit(id, actionType, message) {
        this.$confirm(message, '提示', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
        })
        .then(() => {
            // 用戶確認提交
            this.form.id = id;
            this.form.actionType = actionType; // 可根據 actionType 判斷通過或拒絕的處理
            this.search = this.form;
            this.addOrEdit(this.form,true);
        })
        .catch(() => {
            // 用戶取消提交
            console.log('取消');
        });
    },


  
  
  
  
      // 自定义時間验证规则
      validateTime(rule, value, callback) {
        if (this.formPaper.timeArr.length === 2) {
          const startTime = this.convertTimeToMinutes(this.formPaper.timeArr[0]);
          const endTime = this.convertTimeToMinutes(this.formPaper.timeArr[1]);
          const selectedTime = parseInt(value);
  
          if (isNaN(selectedTime)) {
            callback(new Error("請輸入有效的做題时長"));
          } else if (selectedTime > endTime - startTime) {
            callback(new Error("做題时長不能超過比賽時間范围"));
          } else {
            callback();
          }
        } else {
          callback(new Error("請選擇比賽時間范围"));
        }
      },
      // 辅助方法：将時間转为分钟數
      convertTimeToMinutes(time) {
        const [hours, minutes, seconds] = time.split(":").map(Number);
        return hours * 60 + minutes + seconds / 60;
      },
      changeType() {
        // 清空當前的 label_list
        this.label_list = [];
  
        // 遍历每个 grade_id 来构建键，并合并结果
        this.formPaper.grade_id.forEach((gradeId) => {
          let key = `${this.form.subject_id}-${gradeId}`;
          if (this.all_label_list[key]) {
            this.label_list = [...this.label_list, ...this.all_label_list[key]];
          }
        });
  
        // 移除可能的重复项，假设每个標籤有唯一的 id
        this.label_list = this.label_list.filter(
          (label, index, self) =>
            index === self.findIndex((t) => t.id === label.id)
        );
  
        if (this.label_list.length > 0) {
          // 如果 label_list 不为空，则设置默認选中项为第一个元素的 ID
          this.label_ids = this.label_list[0].id;
        } else {
          // 如果 label_list 为空，可以设置 label_id 为 null 或进行其他逻辑處理
          this.label_ids = null;
        }
      },
      next() {
        if (this.active++ > 2) this.active = 0;
      },
      createModelbut() {
        this.createModel = false;
        this.active = 0;
      },
      createPaperModelbut() {
        this.createPaperModel = false;
      },
      addTag(e = false) {
        // 增加
        if (!e) {
          if (!this.formPaper.grade_id || this.formPaper.grade_id.length === 0) {
            this.$message.error("請選擇先選擇年級!");
            return; // 提前返回，不执行後面的添加或修改逻辑
          }
          (this.topForm.label_id = this.label_ids),
            // 初始化表單
            (this.editTagIndex = -1);
        } else {
          // 修改
          this.topForm = {
            title: e.row.title,
            answer: e.row.answer,
            icon: e.row.img,
            img: e.row.img,
  
            label_id: e.row.label_id,
            label_name: e.row.label_name,
            topic_type: e.row.topic_type,
            option_a: e.row.option_a,
            option_b: e.row.option_b,
            option_c: e.row.option_c,
            option_d: e.row.option_d,
            selectedLabel: e.row.selectedLabel,
            score: e.row.score,
            status: 0,
            use_time: 0,
            sel_time: 0,
            option_sel: "",
          };
          this.editTagIndex = e.$index;
        }
  
        this.createTagModel = true;
      },
  
      handleTagClose(tag) {
        this.topicTags.splice(this.topicTags.indexOf(tag), 1);
      },
  
      //添加題目
      submitTag() {
        this.$refs.topForm.validate((valid) => {
          if (valid) {
            this.handleLabelChange(this.topForm.label_id);
            if (this.editTagIndex === -1) {
              // 添加新題目
              this.formPaper.topList.push(this.topForm);
            } else {
              // 修改现有題目
              this.$set(this.formPaper.topList, this.editTagIndex, {
                ...this.topForm,
              });
            }
  
            // 计算數量和分數總和
            this.formPaper.total_score = this.formPaper.topList.reduce(
              (sum, item) => sum + Number(item.score),
              0
            );
  
            this.formPaper.count = this.formPaper.topList.length;
            // 重置表單和關閉模态框
            this.resetTagForm();
          }
        });
      },
      resetTagForm() {
        this.topForm = {
          title: "",
          answer: "",
          icon: "",
          img: "",
          label_id: this.label_ids,
          label_name: "",
          topic_type: 1,
          option_a: "",
          option_b: "",
          option_c: "",
          option_d: "",
          score: 10,
          status: 0,
          use_time: 0,
          sel_time: 0,
          option_sel: "",
        };
        this.createTagModel = false;
        this.editTagIndex = -1; // 重置 editTagIndex
      },
  
      //添加修改獎品
      addPrize(e = false) {
        if (!e) {
          // 初始化表單
          this.editPrizeIndex = -1;
        } else {
          // 修改
          this.formPrize = {
            name: e.row.name,
            money: e.row.money,
            content: e.row.content,
          };
          this.editPrizeIndex = e.$index;
        }
        // 打开dialog
        this.createPrizeModel = true;
      },
      submitPrize() {
        this.$refs.formPrize.validate((valid) => {
          if (valid) {
            if (this.editPrizeIndex === -1) {
              // 添加新題目
              this.formRanking.prize.push(this.formPrize);
            } else {
              // 修改现有題目
              this.$set(this.formRanking.prize, this.editPrizeIndex, {
                ...this.formPrize,
              });
            }
  
            // 重置表單和關閉模态框
            this.resetPrizeForm();
          }
        });
      },
      resetPrizeForm() {
        this.formPrize = {
          name: "",
          money: 0,
          content: "",
        };
  
        this.createPrizeModel = false;
        this.editPrizeIndex = -1; // 重置 editTagIndex
      },
  
    
      submitRanking() {
        this.$refs.formRanking.validate((valid) => {
          if (valid) {
            if (this.editRankingIndex === -1) {
              // 添加新題目
              this.form.ranking.push(this.formRanking);
            } else {
              // 修改现有題目
              this.$set(this.form.ranking, this.editRankingIndex, {
                ...this.formRanking,
              });
            }
  
            // 重置表單和關閉模态框
            this.resetRankingForm();
          }
        });
      },
      resetRankingForm() {
        this.formRanking = {
          level_name: "",
          prize: [],
          sum: 1,
        };
  
        this.createRankingModel = false;
        this.editRankingIndex = -1; // 重置 editTagIndex
      },
  
      //添加試卷
      submitPaper() {
        this.$refs.formPaper.validate((valid) => {
          if (valid) {
            if (this.editPaperIndex === -1) {
              // 添加新題目
              this.form.paperList.push(this.formPaper);
            } else {
              // 修改现有題目
              this.$set(this.form.paperList, this.editPaperIndex, {
                ...this.formPaper,
              });
            }
  
            // 重置表單和關閉模态框
            this.resetPaperForm();
          }
        });
      },
  
      resetPaperForm() {
        this.formPaper = {
          name: "",
          timeArr: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
          time: 60,
          total_score: 0,
          count: 0,
          topList: [], //題目數組
          grade_id: [], //年級數組
        };
  
        this.createPaperModel = false;
        this.editPaperIndex = -1; // 重置 editTagIndex
      },
      addDomain(e = false) {
        if (!e) {
          // 初始化表單
          this.editPaperIndex = -1;
        } else {
          // 修改
          this.formPaper = {
            name: e.row.name,
            time: e.row.time,
            timeArr: e.row.timeArr,
            total_score: e.row.total_score,
            count: e.row.count,
            topList: e.row.topList,
            grade_id: e.row.grade_id.map((id) => Number(id)),
          };
          this.editPaperIndex = e.$index;
        }
        // 打开dialog
        this.createPaperModel = true;
      },
  
      handleLabelChange(value) {
        if (this.label_list.length > 0) {
          const selectedItem = this.label_list.find((item) => item.id === value);
          this.topForm.label_name = selectedItem.name; // 获取和存储 name
        }
      },
  
      resetForm() {
        this.form = {
          subject_id: null,
          title: "",
          content: "",
          subject_id: this.form.subject_id,
          school_id: [],
          pay_type: 1,
          is_school: 0,
          money: 0,
          time: [],
          com_time: null,
          paperList: [], //試卷數組
          ranking: [], //試卷數組
        };
  
        this.createModel = false;
        this.getList();
        this.editIndex = -1; // 重置 editTagIndex
      },
  
      //公共列表
      commonList(type) {
        this.layout.loading = true;
        this.axios
          .post(
            "/admin/user/commonList",
            {
              type: type,
            },
            {
              token: true,
            }
          )
          .then((res) => {
            let all = res.data;
            let list = all.data.list;
            this.school_list = list.school;
            this.grade_list = list.grade;
            this.subject_list = list.subject;
            this.all_label_list = list.label;
  
            if (this.subject_list.length > 0) {
              // 设置默認选中项为subject_list中的第一个元素
              this.form.subject_id = this.subject_list[0].id;
              this.label_list = list.label[this.subject_list[0].id];
              if (this.label_list.length > 0) {
                // 设置默認选中项为subject_list中的第一个元素
                this.label_ids = this.label_list[0].id;
              }
            }
            this.layout.loading = false;
          })
          .catch((err) => {
            // 失敗
            this.layout.loading = false;
          });
      },
      handleAvatarSuccess(res, file) {
        this.topForm.icon = URL.createObjectURL(file.raw);
        let en_data = commondecrypt(res.encryption);
        res.encryption = JSON.parse(en_data);
        if (res.encryption.code == 1) {
          this.topForm.img = res.encryption.data.list.url;
        }
      },
      beforeAvatarUpload(file) {
        const isJPG =
          file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/gif";
        const isLt2M = file.size / 1024 / 1024 < 2;
  
        if (!isJPG) {
          this.$message.error("文件格式错误!");
        }
        if (!isLt2M) {
          this.$message.error("上傳图片大小不能超過 2MB!");
        }
        return isJPG && isLt2M;
      },
      //前往修改页面
      editItem(obj) {
        this.$router.push({
          name: "set_manager_rule",
          query: {
            item: obj,
          },
        });
      },
      handleClose(done) {
        this.active = 0;
        done();
      },
      getListResult(e) {
        this.tableData = e.list;
        this.check_img_list = e.list.map((item) => {
          return item.head;
        });
      },
      // 清空篩選條件
      clearSearch() {
        this.from = {
          title: "",
          com_no: "",
          ins_name: "",
          pay_type: -1,
          status: -1,
          audit_status: -1,
          start_status: -1,
          time: [],
        };
  
        //this.$refs.buttonSearch.closeSuperSearch();
        this.search = "";
        this.getList();
      },
      // 選擇图片
      chooseImage() {
        this.app.chooseImage((res) => {
          this.$set(this.form, "headUrl", res[0].url);
          this.form["headId"] = res[0].id;
          this.$set(this.form, "headId", res[0].id);
        }, 1);
      },
    },
  };
  </script>
  
  <style>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .selected-row {
    background-color: #f0f9ff !important; /* 选中行的背景颜色 */
  }
  </style>
  